import { useQuery } from "react-query";
import axios from "axios";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const augmentData = (data) => {
  const augmentedData = data.map((record) => {
    return {
      ...record, 
    }
  });
  return augmentedData;
}

const getData = async (tableRef, queryClient, key, extraKeys, useCache, callback) => {
  if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
    return queryClient.getQueryData(key);
  }
  if (useCache) {
    const cachedData = queryClient.getQueryData([...key, '_cached']);
    if (cachedData) {
      if (callback) {callback(cachedData, extraKeys)}
      return cachedData
    };
    const realData = queryClient.getQueryData(key);
    if (realData) {
      if (callback) {callback(realData, extraKeys)}
      return realData;
    }
  }
  let extendedPath = "";
  if (extraKeys) {
    extendedPath = extraKeys.join("/");
  }
  const { data } = await axios.get(
    `${apiSitePrefix}/routerequiredpermitoverrides/list/${extendedPath}`
  );
  if (callback) {callback(data, extraKeys)}
  return augmentData(data);
};

const buildKey = (props) => {
  let key = ['RouteRequiredPermitOverrides'];
  if (props.extraKeys) {
    key = [
      ...key,
      ...props.extraKeys
    ]
  }
  const queryKey = [...key];
  if (props.useCache) {
    queryKey.push('_cached');
  }

  return {key, queryKey};
}

export default function useRouteRequiredPermitOverrides(props) {    
  const options = {
    ...props.options
  }

  const {key, queryKey} = buildKey(props);

  return useQuery(
    queryKey, 
    () => getData(props.tableRef, props.queryClient, key, props.extraKeys, props.useCache, props.callback), 
    options
  );
}

export {buildKey}